<div class="toggleButton toolbarLabel">
  <input type="checkbox" id="matchRegExp" tabindex="0" />
  <label for="matchRegExp" data-l10n-id="pdfjs-find-regexp-checkbox-label"></label>
</div>